export const DELETE_PRESET_CONFIRM_DIALOG =
  'graphSideDialogDeletePresetConfirm';
export const SAVE_SETTINGS_CONFIRM_DIALOG =
  'graphSideDialogSaveSettingsPresetConfirm';
